import { TOOTH_GUM_TYPE } from "../data/constant/toothConstant";

export const TOOTH_CONSTANT = {
  LOWER: "lower",
  UPPER: "upper",
  TOOTH_NUMBER_KEY: "toothNumberKey",
  TOOTH_GUM_TYPE: "toothGumType",
  TOOTH_NUMBER: "toothNumber",
  STAGE_NUMBER: "stageNumber",
};

export const getToothGumType = (path) => {
  const match = path.match(/.*__(LOWER|UPPER)__.*\.stl$/i);
  if (match) {
    return match[1].toLowerCase();
  }
  throw new Error("GetToothGumType fail!");
};

export const getToothNumberFromFilePath = (str) => {
  const regex = /TOOTH_(\d+)/;
  const match = str.match(regex);
  if (match) {
    return parseInt(match[1], 10);
  }

  throw new Error("GetToothNumberFromFilePath fail!");
};

export const getStageNumberFromFilePath = (str) => {
  const regex = /STAGE_(\d+)/;
  const match = str.match(regex);
  if (match) {
    return parseInt(match[1], 10);
  }

  throw new Error("GetStageNumberFromFilePath fail!");
};

export const getToothPathInfoFromFilePath = (path) => {
  const toothGumType = getToothGumType(path);
  const toothNumber = getToothNumberFromFilePath(path);

  return {
    toothGumType,
    toothNumber,
  };
};

export const getOpacity = (toothGumType, sliderVal) => {
  if (toothGumType === TOOTH_GUM_TYPE.UPPER && Number(sliderVal) > 0) {
    return (100 - sliderVal) * 0.01;
  }

  if (toothGumType === TOOTH_GUM_TYPE.LOWER && Number(sliderVal) < 0) {
    return (100 - Math.abs(sliderVal)) * 0.01;
  }

  return 1;
};
